module.exports = __webpack_public_path__ + "img/BS34.5e5d093c.svg";